/* ==========================================================================
   VD Delivery Date Scheduler  (vapedokha)  — bilingual EN / AR
   - Date rail + optional time slots on the cart page & cart drawer.
   - EMIRATE-AWARE earliest day, reusing the emirate the shopper already chose
     in the delivery-estimate widget (localStorage key "vd_emirate"):
       Dubai / Abu Dhabi  -> same-day, today is selectable (Earliest)
       Other emirates     -> next-day, tomorrow is Earliest
       Not chosen yet     -> defaults to next-day (true everywhere)
   - Dates computed in Asia/Dubai (GST) to match the estimate widget.
   - Day/month labels switch to Arabic when the host element has data-ar="1".
   - Saves to cart attributes (Delivery Date / Delivery Time) via /cart/update.js
     and keeps hidden inputs in sync for standard checkout submits.
   ========================================================================== */
(function () {
  'use strict';

  var SAME_DAY = ['Dubai', 'Abu Dhabi'];
  var ALL_EMIRATES = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Umm Al Quwain', 'Ras Al Khaimah', 'Fujairah'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DOW_AR = ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'];
  var MON_AR = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

  function trim(s) { return s.trim(); }
  function pad(n) { return ('0' + n).slice(-2); }

  function getEmirate() {
    try {
      var e = localStorage.getItem('vd_emirate');
      return (e && ALL_EMIRATES.indexOf(e) > -1) ? e : null;
    } catch (e) { return null; }
  }

  // "Today" in Asia/Dubai, as plain calendar parts.
  function uaeParts() {
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit' });
      var o = {};
      f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, mo: +o.month, d: +o.day };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), mo: n.getMonth() + 1, d: n.getDate() };
    }
  }

  function init(root) {
    if (!root || root.dataset.vdInit === '1') return;
    root.dataset.vdInit = '1';

    var isAr = root.dataset.ar === '1';
    var DOWi = isAr ? DOW_AR : DOW;
    var MONi = isAr ? MON_AR : MON;
    var L_EARLIEST = isAr ? 'الأقرب' : 'Earliest';
    var L_UNAVAIL  = isAr ? ' (غير متاح)' : ' (unavailable)';
    var L_SEP      = isAr ? '، ' : ', ';

    var defLead = parseInt(root.dataset.lead || '1', 10);   // used only when emirate unknown
    var range   = parseInt(root.dataset.range || '21', 10);
    var closed  = (root.dataset.closed || '').split(',').map(trim).filter(Boolean);
    var slots   = (root.dataset.slots || '').split('|').map(trim).filter(Boolean);

    var em = getEmirate();
    var lead = em ? (SAME_DAY.indexOf(em) > -1 ? 0 : 1) : defLead;

    var rail   = root.querySelector('.vd-dd__rail');
    var native = root.querySelector('.vd-dd__native');
    var moreBtn= root.querySelector('.vd-dd__more');
    var prevBtn= root.querySelector('.vd-dd__nav--prev');
    var nextBtn= root.querySelector('.vd-dd__nav--next');
    var confirm= root.querySelector('.vd-dd__confirm');
    var confTxt= root.querySelector('.vd-dd__confirm-text');
    var dateInput = root.querySelector('input[name="attributes[Delivery Date]"]');
    var timeInput = root.querySelector('input[name="attributes[Delivery Time]"]');
    var slotsWrap = root.querySelector('.vd-dd__slots');

    var base = uaeParts();
    function dayAt(n) { return new Date(Date.UTC(base.y, base.mo - 1, base.d + n)); }
    function ymd(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
    function pretty(d) { return DOWi[d.getUTCDay()] + L_SEP + d.getUTCDate() + ' ' + MONi[d.getUTCMonth()] + ' ' + d.getUTCFullYear(); }
    function isClosed(d) { return closed.indexOf(String(d.getUTCDay())) > -1; }

    var minDate = ymd(dayAt(lead));
    var maxDate = ymd(dayAt(lead + range - 1));

    var firstOpenFound = false;
    for (var i = 0; i < range; i++) {
      var d = dayAt(lead + i);
      var isClosedDay = isClosed(d);
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'vd-dd__day' + (isClosedDay ? ' is-disabled' : '');
      card.setAttribute('data-date', ymd(d));
      card.setAttribute('aria-label', pretty(d) + (isClosedDay ? L_UNAVAIL : ''));
      var tag = '';
      if (!isClosedDay && !firstOpenFound) { tag = L_EARLIEST; firstOpenFound = true; }
      card.innerHTML =
        '<span class="vd-dd__day-dow">' + DOWi[d.getUTCDay()] + '</span>' +
        '<span class="vd-dd__day-num">' + d.getUTCDate() + '</span>' +
        '<span class="vd-dd__day-mon">' + MONi[d.getUTCMonth()] + '</span>' +
        '<span class="vd-dd__day-tag">' + tag + '</span>';
      if (!isClosedDay) card.addEventListener('click', function (e) { select(e.currentTarget.getAttribute('data-date'), true); });
      rail.appendChild(card);
    }

    // native picker bounds
    if (native) {
      native.min = minDate;
      native.max = maxDate;
      native.addEventListener('change', function () { if (native.value) select(native.value, true); });
    }
    if (moreBtn && native) {
      moreBtn.addEventListener('click', function () {
        if (native.showPicker) { try { native.showPicker(); return; } catch (e) {} }
        native.style.position = 'static'; native.style.width = 'auto'; native.style.height = 'auto';
        native.style.opacity = '1'; native.style.pointerEvents = 'auto'; native.focus(); native.click();
      });
    }

    // scroll arrows
    function scrollRail(dir) {
      if (!rail) return;
      var amt = Math.max(rail.clientWidth * 0.8, 160);
      rail.scrollBy({ left: dir * amt, behavior: 'smooth' });
    }
    function updateArrows() {
      if (!rail) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft); // RTL reports negative scrollLeft in modern browsers
      var atStart = pos <= 2;
      var atEnd = pos >= max - 2;
      if (prevBtn) prevBtn.classList.toggle('is-hidden', atStart);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', atEnd);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollRail(isAr ? 1 : -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollRail(isAr ? -1 : 1); });
    if (rail) rail.addEventListener('scroll', updateArrows, { passive: true });
    setTimeout(updateArrows, 60);

    // time slots
    if (slotsWrap && slots.length) {
      slots.forEach(function (label) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'vd-dd__slot'; b.textContent = label;
        b.addEventListener('click', function () {
          slotsWrap.querySelectorAll('.vd-dd__slot').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          if (timeInput) timeInput.value = label;
          persist();
        });
        slotsWrap.appendChild(b);
      });
    } else if (slotsWrap) {
      slotsWrap.style.display = 'none';
      var lbl = root.querySelector('.vd-dd__label--time'); if (lbl) lbl.style.display = 'none';
    }

    function markSelected(dateStr) {
      rail.querySelectorAll('.vd-dd__day').forEach(function (c) {
        c.classList.toggle('is-selected', c.getAttribute('data-date') === dateStr);
      });
      var sel = rail.querySelector('.vd-dd__day.is-selected');
      if (sel) sel.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }

    function showConfirm(dateStr) {
      var p = dateStr.split('-');
      var d = new Date(Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10)));
      if (confTxt) confTxt.textContent = pretty(d);
      if (confirm) confirm.classList.add('is-on');
    }

    function persist() {
      var attrs = {};
      attrs['Delivery Date'] = dateInput ? dateInput.value : '';
      if (timeInput) attrs['Delivery Time'] = timeInput.value || '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { /* non-blocking */ });
    }

    function select(dateStr, save) {
      if (dateInput) dateInput.value = dateStr;
      markSelected(dateStr);
      showConfirm(dateStr);
      if (save) persist();
    }

    // Restore a previously chosen date only if it's still within the valid window
    if (dateInput && dateInput.value && dateInput.value >= minDate && dateInput.value <= maxDate) {
      select(dateInput.value, false);
    } else if (dateInput && dateInput.value) {
      dateInput.value = '';   // clear stale/out-of-range value
    }
    if (timeInput && timeInput.value && slotsWrap) {
      slotsWrap.querySelectorAll('.vd-dd__slot').forEach(function (x) {
        if (x.textContent === timeInput.value) x.classList.add('is-selected');
      });
    }
  }

  function boot() { document.querySelectorAll('.vd-dd').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  // Re-init when the cart drawer rebuilds after add-to-cart.
  var rebootScheduled = false;
  function scheduleBoot() {
    if (rebootScheduled) return;
    rebootScheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { rebootScheduled = false; boot(); });
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.classList && n.classList.contains('vd-dd') || (n.querySelector && n.querySelector('.vd-dd')))) {
            scheduleBoot(); return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
